import { createAppSlice } from "Data/Redux/Store";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { MaskSettingsState } from "Interfaces";
import { constant, times } from "lodash";

const initialState: MaskSettingsState = {
	maskColor: "red",
	maskEnabled: false,
	zones: times(8, (constant(null)))
};

export const setMaskSettingsReducer = (state: MaskSettingsState, action: PayloadAction<MaskSettingsState>) => {
	return action.payload;
};

export const getMaskSettings = (state: MaskSettingsState) => {
	return state;
};

const maskSlice = createAppSlice({
	name: "mask",
	initialState,
	reducers: {
		setMaskSettingsAction: setMaskSettingsReducer
	},
	selectors: {
		selectMaskSettings: getMaskSettings
	}
});

export default maskSlice;

export const { setMaskSettingsAction } = maskSlice.actions;
export const { selectMaskSettings } = maskSlice.selectors;
